import { logoutAdmin } from "api/auth";
import { resetPostHogUser } from "posthog";

export const logout = async () => {
  // Another tab may have signed out already; calling the API without a token only 401s.
  // A failed call must not keep the user signed in on this device.
  if (localStorage.getItem("token")) await logoutAdmin().catch(() => {});

  resetPostHogUser();
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("central_access_token");
  window.location.assign("/login");
};
